export default __webpack_public_path__ + "static/media/BOD Regular Meeting 17 June 2021.dec94ae4.pdf";